interface CheckpointWarningDescriptionProps {
  transitionLabel?: string;
}

const CheckpointWarningDescription = ({
  transitionLabel,
}: CheckpointWarningDescriptionProps) => {
  return (
    <>
      Vas a escanear pedidos con el checkpoint{' '}
      <span className='font-black text-gray-800'>{transitionLabel}</span>.
      <div className='p-4 rounded-xl bg-amber-50 border border-amber-200 mt-4'>
        <p className='text-amber-900 text-[14px] leading-relaxed m-0'>
          Una vez que comiences a escanear,{' '}
          <strong>no podrás cambiar el checkpoint</strong>. Si necesitás cambiarlo,
          deberás borrar el listado completo y comenzar desde cero.
        </p>
      </div>
    </>
  );
};

export default CheckpointWarningDescription;
